import * as yup from "yup";

export const workOrderNotesSchema = yup.object().shape({
  note: yup.string().required().default(""),
  workOrderId: yup.string().required(),
});
